import { get } from 'lodash';

import { FIELD_PATHS, INCOME_TYPE } from '@funnels/constants';

import { useFormValues } from '../useFormValues';

export function useIncomeOptional(incomeIndex: number, type: INCOME_TYPE) {
  const [formValues] = useFormValues();
  const incomeType = get(formValues, FIELD_PATHS.INCOME_TYPE(incomeIndex));

  if (incomeType !== type) {
    return false;
  }

  const incomeAmount = get(formValues, FIELD_PATHS.INCOME_AMOUNT(incomeIndex));
  const incomeFrequency = get(formValues, FIELD_PATHS.INCOME_FREQUENCY(incomeIndex));

  if (incomeAmount || incomeFrequency) {
    return false;
  }
  return true;
}
